<template>
  <div class="segment-header">
    <span
      v-if="segmentHeaderData.subtitle"
      class="segment-header__pre-heading heading heading--3"
    >
      {{ segmentHeaderData.subtitle | decodeHtml }}
    </span>
    <h1
      v-if="segmentHeaderData.header"
      class="segment-header__heading heading--2"
    >
      {{ segmentHeaderData.header | decodeHtml }}
    </h1>
    <div class="segment-header__container">
      <img
        :src="headerImageSrc"
        :alt="headerImageAlt"
        class="segment-header__image"
      >
      <ul
        class="segment-header__details"
        :style="detailsListStyle"
      >
        <li
          v-if="segmentHeaderData.text1"
          class="segment-header__text segment-header__text--top-left"
          :style="textBubbleStyle"
        >
          {{ segmentHeaderData.text1 | decodeHtml }}
          <div
            class="segment-header__triangle segment-header__triangle--right"
            :style="triangleRightStyle"
          />
        </li>

        <li
          v-if="segmentHeaderData.text2"
          class="segment-header__text segment-header__text--top-right"
          :style="textBubbleStyle"
        >
          {{ segmentHeaderData.text2 | decodeHtml }}
          <div
            class="segment-header__triangle segment-header__triangle--left"
            :style="triangleLeftStyle"
          />
        </li>

        <li
          v-if="segmentHeaderData.text3"
          class="segment-header__text segment-header__text--bottom-left"
          :style="textBubbleStyle"
        >
          {{ segmentHeaderData.text3 | decodeHtml }}
          <div
            class="segment-header__triangle segment-header__triangle--right"
            :style="triangleRightStyle"
          />
        </li>

        <li
          v-if="segmentHeaderData.text4"
          class="segment-header__text segment-header__text--bottom-right"
          :style="textBubbleStyle"
        >
          {{ segmentHeaderData.text4 | decodeHtml }}
          <div
            class="segment-header__triangle segment-header__triangle--left"
            :style="triangleLeftStyle"
          />
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SegmentHeader',
  props: {
    segmentHeaderData: {
      type: Object,
      required: true,
    },
    featuredMedia: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      textColor: this.segmentHeaderData.textColor,
      bubbleColor: this.segmentHeaderData.backgroundColor,
    };
  },
  computed: {
    detailsListStyle() {
      return {
        background: this.bubbleColor,
      };
    },
    textBubbleStyle() {
      return {
        color: this.textColor,
        background: this.bubbleColor,
      };
    },
    triangleRightStyle() {
      return {
        borderLeftColor: this.bubbleColor,
      };
    },
    triangleLeftStyle() {
      return {
        borderRightColor: this.bubbleColor,
      };
    },
    headerImageSrc() {
      if (this.featuredMedia[0]) {
        return this.featuredMedia[0].url;
      }
      return '/common/nexus/segment-header-placeholder.png';
    },
    headerImageAlt() {
      return this.featuredMedia[0] ? this.featuredMedia[0].alt : 'community member';
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '@/stylesheets/components/_segment-header';
</style>

<docs>
</docs>
